exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.course-tabs .qa-question {\n  font-size: 14px;\n}\n.course-tabs .qa-answer {\n  margin-top: 0.5em;\n  margin-left: 2em;\n  font-style: italic;\n  font-size: 14px;\n}\n.course-tabs .font12px {\n  font-size: 12px;\n}\n.course-tabs .qa-box {\n  background-color: #f0f8ff;\n}\n.course-tabs .fa-comments-o {\n  padding-bottom: 3px !important;\n}\n", ""]);

// exports
